<template>
    <van-popup v-model="show">
        <div class="popup">
            <div class="popup__title">{{ name }}</div>
            <div class="popup__desc">{{ dtl }}</div>
            <img class="popup__img" src="@/assets/mobile-imgs/downloadtip.png" />
            <p class="popup__tip">下载请移步至网页端</p>
            <button type="button" class="popup__btn" @click="onReturn">返回</button>
        </div>
    </van-popup>
</template>

<script>
export default {
    name: 'TheDialogDtl',

    data() {
        return {
            show: false,
            name: '',
            dtl: ''
        };
    },

    computed: {},

    methods: {
        open(name, dtl) {
            console.log(name, dtl);
            this.name = name;
            this.dtl = dtl;
            this.show = true;
        },

        onReturn() {
            this.show = false;
        }
    }
};
</script>

<style lang="scss" scoped>
.popup {
    width: 300px;
    max-height: 80vh;
    padding: 20px 20px 80px;
    box-sizing: border-box;
    overflow: auto;
    &__title {
        font-size: 16px;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.6);
        line-height: 22px;
        margin-bottom: 12px;
    }
    &__desc {
        font-size: 13px;
        color: rgba(0, 0, 0, 0.6);
        line-height: 18px;
    }
    &__img {
        display: block;
        width: 56px;
        margin: 30px auto 12px;
    }
    &__tip {
        font-size: 12px;
        color: rgba(0, 0, 0, 0.6);
        line-height: 17px;
        text-align: center;
    }
    &__btn {
        width: 100%;
        height: 60px;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        border: none;
        border-top: 1px solid #eaeaea;
        background: #fff;
        font-size: 16px;
        font-weight: 600;
        color: #047aff;
    }
}
</style>
